/* announcement bar promo code copy js start */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize promo code copy functionality
  const copyPromoCodeImg = document.querySelector('.copy-promo-code-img');
  if (copyPromoCodeImg) {
    copyPromoCodeImg.addEventListener('click', copyPromoCode);
  }
});

function copyPromoCode() {
  const promoCode = document.getElementById('promo-code').textContent;
  navigator.clipboard.writeText(promoCode).then(() => {
    // Show a temporary tooltip or notification
    const tooltip = document.createElement('div');
    tooltip.textContent = 'Promo code copied!';
    tooltip.style.cssText = `
      position: fixed;
      top: 11%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #10b981;
      color: white;
      padding: 10px 20px;
      border-radius: 4px;
      z-index: 9999;
      font-size: 14px;
    `;
    document.body.appendChild(tooltip);
    
    // Remove the tooltip after 2 seconds
    setTimeout(() => {
      tooltip.remove();
    }, 3000);
  }).catch(err => {
    console.error('Failed to copy promo code:', err);
  });
}
/* announcement bar promo code copy js end */
/* ======================================================================== */